var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSbov2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "#ffdf1a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "provider/icon/sbo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.9852008,15.8080514 L20.4740695,17.6047715 L23.6298592,20.2469655 C24.1588522,20.6895898 24.2278206,21.4762818 23.7840239,22.0039111 L15.7992109,31.4984214 C15.5617903,31.7808914 15.2111274,31.9440376 14.8417672,31.9440376 L12.3858921,31.9440376 C11.8549589,31.9440376 11.565856,31.3252436 11.9069939,30.919578 L13.6638362,28.8305323 L13.6638362,28.8305323 L19.8614678,21.4611464 L15.7482343,18.0173008 L19.2506299,13.852585 L19.415378,13.6565279 L21.5715668,11.0926511 L23.5291406,8.76513388 C23.7665613,8.48266393 24.1172242,8.31951773 24.4865844,8.31951773 L26.9424594,8.31951773 C27.4733927,8.31951773 27.7624955,8.93831173 27.4211813,9.3439773 L24.1413896,13.2441746 L21.9852008,15.8080514 Z M29.0529632,13.8318177 C28.537905,14.1405107 27.9558187,14.3312879 27.3396892,14.384966 C26.5113628,14.4580034 25.7012045,14.2754979 24.9951162,13.8717683 L28.2318688,10.0227852 C28.6571445,9.51715514 28.7476325,8.83148352 28.4680547,8.2332808 C28.1884769,7.63525407 27.6039211,7.26355529 26.9424594,7.26355529 L26.9424594,7.26355529 L24.4865844,7.26355529 C23.8025448,7.26373128 23.1580165,7.56344862 22.7184532,8.08632603 L20.7608793,10.4140192 L18.7424509,8.72395135 C17.2318488,7.45908433 15.3178432,6.85736173 13.3535665,7.02860364 C12.8450348,7.07295406 12.3504378,7.17063059 11.8734798,7.31512145 C11.3460743,7.47492377 10.98571,7.96137047 10.98571,8.51135091 L10.98571,10.3811084 C10.98571,10.8663232 11.5157613,11.1656885 11.9327468,10.9157774 C12.4476286,10.6072604 13.0297149,10.4166591 13.6458444,10.3629811 C14.7184707,10.2693524 15.7618163,10.5979327 16.5860858,11.2878282 L16.8457315,11.5051804 L11.8267365,17.4731282 C11.3824106,18.0014614 11.451379,18.7893854 11.9810776,19.2327136 L15.1354562,21.8736757 L10.1476821,27.8046648 C9.80583871,28.2110343 10.0954707,28.8307083 10.6271096,28.8305323 L12.2823513,28.8305323 L11.0963064,30.2407701 C10.671207,30.7464001 10.580719,31.4320718 10.8602969,32.0300985 C11.1396983,32.6283012 11.7244304,33 12.3858921,33 L14.8417672,33 C15.5258068,33 16.170335,32.7001067 16.6100748,32.1772293 L24.5947113,22.6827189 C25.4128072,21.7098255 25.2852774,20.2543573 24.3101946,19.4379223 L21.9650924,17.4747121 L22.8189953,16.4594042 C24.0466683,17.3011823 25.4844214,17.7480304 26.9757971,17.7480304 C27.1934621,17.7478544 27.4125382,17.7385268 27.6319671,17.7191674 C28.1404989,17.674817 28.6352722,17.5771405 29.1124066,17.4326496 C29.6398121,17.2728473 30,16.7864006 30,16.2364202 L30,14.3664867 C30,13.8812719 29.4699487,13.5819066 29.0529632,13.8318177 L29.0529632,13.8318177 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-20.0%",
    y: "-7.7%",
    width: "140.0%",
    height: "130.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0996264478 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-12.5%",
    y: "-1.9%",
    width: "125.0%",
    height: "119.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "provider/icon/sbo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sbo"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#ffdf1a",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ffdf1a",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ffdf1a",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSbov2);
export default __webpack_public_path__ + "static/media/icon-sbov2.a822b5bb0c1f8df9d99790bf89c99a32.svg";
export { ForwardRef as ReactComponent };